import React, { useContext, useState } from 'react';
import { Grid } from '@mui/material';
import { StaticTimeFilterType } from './StaticTimeFilterType';
import { CompanyContext } from '../../../../context/CompanyContext';
import { Colors } from '../../../util/color.util';
import { MetricFilter, MetricInterval } from '../../../../types/metrics/metricFilter';

interface StaticTimeFilterProps {
  filter: MetricFilter;
  setFilter: (filter: MetricFilter) => void;
}

export function StaticTimeFilter({ filter, setFilter }: StaticTimeFilterProps) {
  const { currentCompany } = useContext(CompanyContext);

  const [timeFrame, setTimeFrame] = useState<string>(StaticTimeFilterType.WEEK);

  const items = StaticTimeFilterType.keys();

  const handleClick = (item: string) => {
    const { start, end, interval } = StaticTimeFilterType.getTimeFrame(item);

    filter.start = start;
    filter.end = end;
    filter.interval = interval || MetricInterval.day;

    setTimeFrame(item);
    setFilter(new MetricFilter(filter));
  };

  const backgroundColor = (item: string) => {
    if (timeFrame === item) return Colors.companyLightBackground(currentCompany);
    return '#FFFFFF';
  };

  const textColor = (item: string) => {
    if (timeFrame === item) return Colors.companyDarkText(currentCompany);
    return '#697586';
  };

  const borderColor = (item: string) => {
    if (timeFrame === item) return backgroundColor(item);
    return '#F2F4F7';
  };

  const borderClass = (idx: number) => {
    if (idx === 0) return 'border-gray-100 border-l border-t border-b';
    if (idx === items.length - 1) return 'border-gray-100 border-r border-t border-b';
    return 'border-t border-b';
  };

  return (
    <div className='h-[28px] w-fit'>
      <Grid container className='h-full'>
        {items.map((item, idx) => {
          return (
            <Grid
              key={item}
              item
              onClick={() => handleClick(item)}
              bgcolor={backgroundColor(item)}
              borderColor={borderColor(item)}
              className={`my-auto flex h-full cursor-pointer ${borderClass(idx)}`}
            >
              <p
                style={{ color: textColor(item) }}
                className='my-auto cursor-pointer select-none px-3 text-[13px] font-[500]'
              >
                {StaticTimeFilterType.toLocalizedString(item)}
              </p>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
}
